import { ErrorBoundary, Layout } from '@/components';
import { default as NetworkPage } from '@/pages';
import OverallActivityPage from '@/pages/activity';
import OverallEventsPage from '@/pages/activity/events';
import UnderwaterWalletsPage from '@/pages/underwaterWallets';
import LiquidationsPage from '@/pages/liquidations';
import LiquidatorsPage from '@/pages/liquidations/liquidators';
import LiquidatorPage from '@/pages/liquidations/liquidators/liquidator';
import MarketsPage from '@/pages/markets';
import MarketPage from '@/pages/markets/marketAddress';
import MarketActivityPage from '@/pages/markets/marketAddress/activity';
import MarketCollateralPage from '@/pages/markets/marketAddress/collateral';
import MarketDebtPage from '@/pages/markets/marketAddress/debt';
import MarketWalletsPage from '@/pages/markets/marketAddress/wallets';
import MarketWalletPage from '@/pages/markets/marketAddress/wallets/walletAddress';
import WalletMarketActivityPage from '@/pages/markets/marketAddress/wallets/walletAddress/activity';
import MarketParametersPage from '@/pages/parameters';
import TreasuryPage from '@/pages/treasury';
import WalletsPage from '@/pages/wallets';
import WalletPage from '@/pages/wallets/walletAddress';
import WalletActivityPage from '@/pages/wallets/walletAddress/activity';
import { createBrowserRouter } from 'react-router';
import ValidateNetwork from './ValidateNetwork';

const router = createBrowserRouter([
  {
    errorElement: (
      <Layout>
        <ErrorBoundary />
      </Layout>
    ),
    children: [
      {
        element: <ValidateNetwork />,
        children: [
          {
            index: true,
            element: <NetworkPage />
          },
          {
            path: 'activity',
            element: <OverallActivityPage />
          },
          {
            path: 'activity/events',
            element: <OverallEventsPage />
          },
          {
            path: 'wallets',
            element: <WalletsPage />
          },
          {
            path: 'underwater-wallets',
            element: <UnderwaterWalletsPage />
          },
          {
            path: 'wallets/:walletAddress',
            element: <WalletPage />
          },
          {
            path: 'wallets/:walletAddress/activity',
            element: <WalletActivityPage />
          },
          {
            path: 'markets',
            element: <MarketsPage />
          },
          {
            path: 'liquidations',
            element: <LiquidationsPage />
          },
          {
            path: 'liquidations/liquidators',
            element: <LiquidatorsPage />
          },
          {
            path: 'liquidations/liquidators/:liquidatorAddress',
            element: <LiquidatorPage />
          },
          {
            path: 'markets/:marketAddress',
            element: <MarketPage />
          },
          {
            path: 'markets/:marketAddress/debt',
            element: <MarketDebtPage />
          },
          {
            path: 'markets/:marketAddress/collateral',
            element: <MarketCollateralPage />
          },
          {
            path: 'markets/:marketAddress/activity',
            element: <MarketActivityPage />
          },
          {
            path: 'markets/:marketAddress/wallets',
            element: <MarketWalletsPage />
          },
          {
            path: 'markets/:marketAddress/wallets/:walletAddress',
            element: <MarketWalletPage />
          },
          {
            path: 'parameters',
            element: <MarketParametersPage />
          },
          {
            path: 'markets/:marketAddress/wallets/:walletAddress/activity',
            element: <WalletMarketActivityPage />
          },
          {
            path: 'treasury',
            element: <TreasuryPage />
          }
        ]
      }
    ]
  }
]);

export default router;
